<template>
<div class="content-page">
    <div class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="page-title-box">
                    <h4 class="page-title">
                        고시원 {{ kosiwonId ? "정보 수정" : "신규 등록" }}
                    </h4>
                </div>
            </div>
            <div class="row">
                <div class="card">
                    <div class="card-body">
                        <div id="progressbarwizard">
                            <ul class="nav nav-pills nav-justified form-wizard-header mb-4" id="kosiwonTabList">
                                <li class="nav-item">
                                    <a href="#default-info" id="default-info-tab" data-bs-toggle="tab" data-toggle="tab" class="nav-link rounded-0 py-2">
                                        <i class="mdi mdi-home-account font-18 align-middle me-1"></i>
                                        <span class="d-sm-inline">기본</span>
                                    </a>
                                </li>
                                <li class="nav-item">
                                    <a href="#option-info" id="option-info-tab" data-bs-toggle="tab" data-toggle="tab" class="nav-link rounded-0 py-2">
                                        <i class="mdi mdi-information-outline font-18 align-middle me-1"></i>
                                        <span class="d-sm-inline">옵션</span>
                                    </a>
                                </li>
                                <li class="nav-item">
                                    <a href="#image-info" id="image-info-tab" data-bs-toggle="tab" data-toggle="tab" class="nav-link rounded-0 py-2">
                                        <i class="mdi mdi-image-multiple-outline font-18 align-middle me-1"></i>
                                        <span class="d-sm-inline">사진</span>
                                    </a>
                                </li>
                            </ul>
                            <div class="tab-content b-0 mb-0">
                                <!-- Progress Bar -->
                                <div id="bar" class="progress mb-4" style="height: 7px;">
                                    <div class="bar progress-bar progress-bar-striped progress-bar-animated bg-success"></div>
                                </div>

                                <!-- 기본 정보 탭 -->
                                <div class="tab-pane" id="default-info">
                                    <DefaultInfo :kosiwon="kosiwon" :btnText="btnText" @validate-field="validateField" @open-confirm-modal="openConfirmModal" />
                                </div>

                                <!-- 옵션 정보 탭 -->
                                <div class="tab-pane" id="option-info">
                                    <OptionInfo :kosiwon="kosiwon" :options="options" :useSexType_options="useSexType_options" :heatingType_options="heatingType_options" :roomType_options="roomType_options" :isWideScreen="isWideScreen" :btnText="btnText" @open-confirm-modal="openConfirmModal" />
                                </div>

                                <!-- 이미지 정보 탭 -->
                                <div class="tab-pane" id="image-info">
                                    <ImageInfo :kosiwon="kosiwon" :btnText="btnText" @open-confirm-modal="openConfirmModal" />
                                </div>

                                <!-- Prev / Next Btn -->
                                <div class="float-start d-none d-sm-inline">
                                    <input type="button" class="btn btn-info button-previous me-1" name="previous" value="이전" />
                                    <input type="button" class="btn btn-info button-next" name="next" value="다음" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <KosiwonRegisterConfirmModal :btnText="btnText" @save-kosiwon="saveKosiwon" />
</div>
</template>

<script>
import {
    REG_EXP
} from "@/config/const.js";
import common from "@/mixins/common.js";

import DefaultInfo from "@/components/kosiwon/DefaultInfo";
import OptionInfo from "@/components/kosiwon/OptionInfo";
import ImageInfo from "@/components/kosiwon/ImageInfo";

import KosiwonRegisterConfirmModal from "@/components/modal/KosiwonRegisterConfirm";

export default {
    components: {
        DefaultInfo,
        OptionInfo,
        ImageInfo,
        KosiwonRegisterConfirmModal
    },
    mixins: [
        common
    ],
    data() {
        return {
            // kosiwonId 전달되면 수정모드
            kosiwonId: this.$route.params.id,

            allowRouteLeave: false,
            isWideScreen: false,
            priceSlider: null,
            depositSlider: null,

            kosiwon: {
                name: "", // 고시원명
                branch: "", // 지점명
                address_brief: "", // 주소
                address_detail: "", // 상세주소
                lat: null, // 위도
                lng: null, // 경도,
                owner_name: "", // 업주이름
                company_registration_number: "", // 사업자번호
                url: "", // 홈페이지 URL

                phone_no: "", // 유선번호
                cellphone_no: "", // 원장 핸드폰번호
                virtual_no: "", // 가상번호 (저장 후 등록 가능)
                floor: "", // 고시원 층수
                building_floor: "", // 건물 전체 층수
                price_min: "", // 최소 금액
                price_max: "", // 최대 금액
                deposit: 0, // 보증금

                heating_type: "N", // 난방정보 (default 없음)
                room_type: "", // 룸 타입 (default 없음)

                traffics_subway: [], // 지하철 정보

                intro: "", // 한줄 소개
                description: "", // 상세 설명

                thumbnail_url: null, // 썸네일 이미지 (고시락 메인 썸네일 / 지도 검색 썸네일)

                // {image_url: "https://via.placeholder.com/300/FFFFFF?text=1"}
                categories: [{
                    category_name: "기본",
                    groups: [{
                        group_name: "기본",
                        images: []
                    }]
                }],
                options: {},

                private_memo: "", // 비공개 메모
                manager_phone_no: "", // 총무 핸드폰번호
                kakao_talk_receiver: "W", // 카카오 알림톡 대상 (default 원장)
                package_type: "N", // 패키지 타입 (default 없음)
                package_renew_month: 0, // 패지키 갱신주기
                package_register_date: null, // 패키지 계약 시작일
                package_end_date: null, // 패키지 계약 종료일

                is_active: false
            },
            options: [
                // line-1    
                {
                    value: "is_parking",
                    text: "주차장",
                    checked: false
                },
                {
                    value: "is_elevator",
                    text: "엘리베이터",
                    checked: false
                },
                {
                    value: "is_meal",
                    text: "식사 제공",
                    checked: false
                },
                {
                    value: "is_restroom",
                    text: "개별 화장실",
                    checked: false
                },
                {
                    value: "is_kitchen",
                    text: "공용 주방",
                    checked: false
                },

                // line-2
                {
                    value: "is_washroom",
                    text: "공용 세탁기",
                    checked: false
                },
                {
                    value: "is_dry",
                    text: "공용 건조기",
                    checked: false
                },
                {
                    value: "is_cctv",
                    text: "CCTV",
                    checked: false
                },
                {
                    value: "is_double_room",
                    text: "2인실",
                    checked: false
                },
                {
                    value: "is_sprinkler",
                    text: "스프링쿨러",
                    checked: false
                },

                // line-3
                {
                    value: "option_desk",
                    text: "책상",
                    checked: false
                },
                {
                    value: "option_bed",
                    text: "침대",
                    checked: false
                },
                {
                    value: "option_refrigerator",
                    text: "개별 냉장고",
                    checked: false
                },
                {
                    value: "option_fan",
                    text: "선풍기",
                    checked: false
                },
                {
                    value: "option_aircon",
                    text: "개별 에어컨",
                    checked: false
                },

                // line-4
                {
                    value: "option_closet",
                    text: "옷장",
                    checked: false
                },
                {
                    value: "option_wash",
                    text: "개별 세탁기",
                    checked: false
                },
                {
                    value: "option_doorlock",
                    text: "개별 도어락",
                    checked: false
                },
                {
                    value: "option_tv",
                    text: "TV / 모니터",
                    checked: false
                },
                {
                    value: "option_internet",
                    text: "인터넷(WI-FI)",
                    checked: false
                }
            ],
            useSexType_options: [{
                    value: "U",
                    text: "성별 무관",
                    checked: true
                },
                {
                    value: "S",
                    text: "남녀 층 분리",
                    checked: false
                },
                {
                    value: "M",
                    text: "남성 전용",
                    checked: false
                },
                {
                    value: "W",
                    text: "여성 전용",
                    checked: false
                }
            ],

            heatingType_options: [{
                    value: "N",
                    text: "없음",
                    checked: true
                },
                {
                    value: "C",
                    text: "중앙 난방",
                    checked: false
                },
                {
                    value: "S",
                    text: "개별 난방",
                    checked: false
                }
            ],

            roomType_options: [{
                    value: "O",
                    text: "원룸",
                    checked: true
                },
                {
                    value: "S",
                    text: "샤워룸",
                    checked: false
                },
                {
                    value: "M",
                    text: "미니룸",
                    checked: false
                }
            ]
        };
    },
    beforeRouteLeave(to, from, next) {
        if (this.allowRouteLeave) {
            $(".modal").modal("hide");
            next();
        } else {
            if (confirm("정말 이 페이지를 떠나시겠습니까?\n작성 중인 내용이 저장되지 않을 수 있습니다.")) {
                $(".modal").modal("hide");
                next();
            } else {
                next(false);
            }
        }
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.checkScreenWidth);
    },
    computed: {
        btnText: function () {
            return this.kosiwonId ? "수정" : "저장";
        }
    },
    async mounted() {
        // * 수정 모드일 경우, 고시원 정보 가져오기
        if (this.kosiwonId) {
            try {
                const res = await this.axios.get(`/kosiwon/${this.kosiwonId}`);

                if (res.data.result) {
                    this.kosiwon = res.data.result;

                    console.log(this.kosiwon);
                    

                    this.setupBeforeLoad();
                } else {
                    alert("존재하지 않는 고시원이거나, 잘못된 접근입니다.");
                    this.allowRouteLeave = true;
                    this.$router.push({
                        path: "/kosiwon/list"
                    });
                }
            } catch (error) {
                console.log(error);
            }
        }

        this.$nextTick(() => {
            this.$store.commit("INIT_BOOTSTRAP_WIZARD", "progressbarwizard");
            this.$store.commit("INIT_RANGE_SLIDER");
            this.$store.commit("INIT_TOOLTIP");

            this.priceSlider = $("#price").data("ionRangeSlider");
            this.depositSlider = $("#deposit").data("ionRangeSlider");

            this.checkScreenWidth();
            window.addEventListener("resize", this.checkScreenWidth);

            // * 수정 모드일 경우, 페이지가 완전히 로드 후, 실행되어야 하는 부분
            if (this.kosiwonId) {
                this.setupAfterLoad();
            }
        });
    },
    methods: {
        setupBeforeLoad() {
            // * 카테고리 존재하지 않는 경우, default 셋팅
            if (this.kosiwon.categories.length <= 0 || !this.kosiwon.categories) {
                this.kosiwon.categories = [{
                    category_name: "기본",
                    groups: [{
                        group_name: "기본",
                        images: []
                    }]
                }];
            }

            // * 옵션 값 셋팅
            this.options.forEach(option => option.checked = this.kosiwon.options[option.value]);

            // * 사용자 구분 값 셋팅
            this.useSexType_options.forEach(option => option.checked = (option.value === this.kosiwon.options.use_sex_type));

            // * 난방 타입 셋팅
            this.heatingType_options.forEach(option => option.checked = (option.value === this.kosiwon.heating_type));

            // * 룸 타입 셋팅 (다중 선택)
            const roomArray = this.kosiwon.room_type.split(",");
            this.roomType_options.forEach(option => {
                option.checked = roomArray.includes(option.value);
            });
        },
        setupAfterLoad() {
            // * 고시원 금액 셋팅
            this.priceSlider.update({
                from: this.kosiwon.price_min,
                to: this.kosiwon.price_max
            });

            // * 보증금 셋팅
            this.depositSlider.update({
                from: this.kosiwon.deposit || 0
            });
        },
        checkScreenWidth() {
            this.isWideScreen = window.innerWidth >= 576;
        },
        moveCardTab(num) {
            const tabs = {
                1: "#default-info-tab",
                2: "#option-info-tab",
                3: "#image-info-tab"
            };

            $(tabs[num]).tab("show");
        },
        validateField(field) {
            const value = this.kosiwon[field].trim();
            let isValid = value === "";

            if (field === "phone_no" || field === "cellphone_no") {
                isValid = !REG_EXP.PHONE.test(value);
            }

            $(`#${field}`).toggleClass("is-invalid", isValid);
            return isValid;
        },
        defaultInfoValidation() {
            const errors = [];

            const validations = [
                "name", "owner_name", "company_registration_number",
                "address_brief", "address_detail", "floor", "building_floor",
                "phone_no", "cellphone_no",
                "intro", "description"
            ];

            this.kosiwon.price_min = this.priceSlider.result.from;
            this.kosiwon.price_max = this.priceSlider.result.to;
            this.kosiwon.deposit = this.depositSlider.result.from;

            for (const field of validations) {
                if (this.validateField(field)) {
                    errors.push(field);
                }
            }

            if (errors.length > 0) {
                alert("기본 정보에 올바른 값을 입력해주세요.\n대표 번호 및 휴대폰 번호가 형식에 맞지 않을 수 있습니다.");
                this.moveCardTab(1);
                return false;
            }

            return true;
        },
        optionInfoValidation() {
            const checked_options = this.options.filter(item => item.checked);

            if (checked_options <= 0) {
                alert("고시원 옵션을 한 개 이상 선택해주세요.");
                this.moveCardTab(2);
                return false;
            }

            this.kosiwon.room_type = this.roomType_options.filter(item => item.checked).map(item => item.value).join(",");
            if (this.kosiwon.room_type === "") {
                alert("룸 타입을 최소 1개 이상 선택해주세요.");
                this.moveCardTab(2);
                return false;
            }

            for (const subway of this.kosiwon.traffics_subway) {
                if (subway.station_number.trim() === "" || subway.intro.trim() === "") {
                    alert("지하철 호선과 역 이름을 입력해주세요.");
                    return false;
                }
            }

            this.options.forEach(option => this.kosiwon.options[option.value] = option.checked);
            this.kosiwon.options.use_sex_type = this.useSexType_options.find(item => item.checked).value;
            this.kosiwon.heating_type = this.heatingType_options.find(item => item.checked).value;

            return true;
        },
        imageInfoValidation() {
            if (this.kosiwon.thumbnail_url === null) {
                alert("고시원 대표 사진을 등록해주세요.");
                this.moveCardTab(3);
                return false;
            }

            if (this.kosiwon.categories[0].groups[0].images.length <= 0) {
                alert("고시원 사진을 한개 이상 등록해주세요.");
                this.moveCardTab(3);
                return false;
            }

            return true;
        },
        openConfirmModal() {
            if (this.defaultInfoValidation() && this.optionInfoValidation() && this.imageInfoValidation()) {
                $("#register-confirm-modal").modal("show");
            }
        },
        async saveKosiwon() {
            try {
                this.loadingOverlay(true);

                const reqUrl = this.kosiwonId ? `/kosiwon/${this.kosiwonId}` : `/kosiwon`;
                const kosiwonResult = await this.axios.post(reqUrl, this.kosiwon);

                await this.axios.post(`/kosiwons/images`, {
                    clientCategoryList: this.kosiwon.categories,
                    kosiwonPk: kosiwonResult.data.result.pk,
                    is_update: !!this.kosiwonId
                });

                this.allowRouteLeave = true;
                alert("정상적으로 등록이 완료 되었습니다.\n내용을 검토하여 신속하게 입력해 주신 연락처로 안내 드리겠습니다.\n감사합니다.");
                this.$router.push({
                    path: "/kosiwon/list"
                });
            } catch (error) {
                console.log(error);
                alert("고시원 등록 중 예기치 못한 에러가 발생하였습니다.\n다시 시도해주세요.");
            } finally {
                this.loadingOverlay(false);
            }
        }
    }
}
</script>

<style>
.btn-sm-custom {
    --ct-btn-padding-y: 0.2rem;
    --ct-btn-padding-x: 0.2rem;
    --ct-btn-font-size: 0.8rem;
    opacity: 0.8;
}

.btn-sm-custom:hover {
    opacity: 1;
}

.avatar-title-custom {
    display: flex;
    flex-direction: column;
    align-items: center;
    border: 1px solid lightgray;
    background: none;
    opacity: 0.5;
}

.avatar-title-custom:hover {
    opacity: 1;
}

.avatar-title-custom i {
    display: block;
    margin-bottom: 5px;
    /* 아이콘과 텍스트 사이의 간격 */
}

.avatar-title-custom span {
    display: block;
}

.image-container {
    position: relative;
    display: inline-block;
}

.button-group {
    position: absolute;
    top: 10px;
    right: 10px;
}

.button-group button {
    margin-left: 5px;
}
</style>
